<template>
  <div class="action-dispatcher">
    <template v-if="loading">
      <div
        v-if="small"
        class="d-flex justify-content-center align-items-center"
      >
        <b-spinner variant="primary" small />
      </div>
      <div v-else class="d-flex justify-content-center p-9">
        <b-spinner
          variant="primary"
          style="width: 3rem; height: 3rem;"
          :class="loadingClass"
        />
      </div>
    </template>

    <div
      v-else-if="error"
      class="dispatch-error centering text-center"
      :class="{ 'p-9': !small }"
    >
      <img
        v-if="!small"
        class="d-block mb-6 mx-auto"
        src="@/assets/images/home/welcome.png"
      />
      <div v-if="!small" class="text-secondary mb-5">
        O recurso que você está buscando não foi encontrado.
      </div>
      <button class="btn-link btn" @click="dispatch">
        Tentar novamente
      </button>
    </div>

    <slot v-else v-bind:data="data" />
  </div>
</template>

<script>
export default {
  props: {
    action: {
      type: String,
      required: true
    },
    parameters: {
      type: [Object, Number, String],
      default: null
    },
    loadingClass: {
      type: String,
      default: ""
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: true,
      error: false,
      data: null
    };
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    dispatch() {
      this.loading = true;
      this.$store
        .dispatch(this.action, this.parameters)
        .then(data => {
          this.error = false;
          this.data = data;
          this.$emit("success", data);
        })
        .catch(er => {
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.action-dispatcher {
  .dispatch-error {
    max-width: 400px;
    margin: auto;
  }
}
</style>
